// extracted by mini-css-extract-plugin
export default {"radiusXs":"2px","radiusS":"4px","radiusM":"8px","radiusL":"16px"};